import { IFeedItem } from './api';
import { ILanguage } from './i18n';
import { INpcAvatar } from './npcBase';

export interface INpcAvatarInfo {
  thumbnail_avatar_url?: string;
  avatar_list?: INpcAvatar[];
}

export interface IAuthor {
  user_id?: number;
  user_name?: string;
  user_avatar_url?: string;
}

export interface IImInfo {
  im_account?: string;
}

export enum EModerationDecision {
  DoingModeration = 0,
  VisibleAll = 100,
  VisibleSelf = 200,
  VisibleNone = 300,
}

export enum ENextVersionStatus {
  NextVersionDoingModeration = 1,
  NoNextVersion = 2,
}

export enum EStepDecision {
  FirstPass = 1,
  SecondPass = 2,
  ThirdPass = 3,
  SelfSee = 100,
  NotPass = 200,
}

export enum EDiscouragedContent {
  Appropriate = 1,
  MinorContent = 2,
  AdultContent = 3,
  HorrorAndViolence = 4,
  ImageGenerationErrors = 5,
  LowQuality = 6,
  UnwholesomeContent = 7,
  Other = 20,
}

export interface IModerationStatus {
  final_decision?: EModerationDecision;
  next_version_status?: ENextVersionStatus;
  step_decision?: EStepDecision;
  discouraged_content?: EDiscouragedContent;
  user_can_chat?: boolean;
  user_can_share?: boolean;
}
export enum ECardType {
  AuthorCreate = 1,
  AICreate = 2,
}

export interface IBackgroundImg {
  img_url?: string;
  depth_img_url?: string;
  img_type?: ECardType;
  small_thumbnail_img_url?: string;
}

export interface ISuggestMsgElem {
  msg?: string;
  msg_id?: number;
}

export enum NpcSeoSource {
  none = 1, // 没有任何来源，自行生产的
  character_ai = 2, // cai爬取
  crushon = 3, // crushon爬取
}

export interface IExtraInfo {
  created_at?: number;
  has_direct_card?: boolean;
  prologue_suggest_msgs?: ISuggestMsgElem;
  seo_source?: NpcSeoSource;
}

export enum EFollowType {
  Default = 0, // 未关注
  Following = 1, // 我关注他，他不关注我
  Followers = 2, // Deprecated
  MutualFollow = 3, // Deprecated
}

export interface IStatisticInfo {
  followers_count: number; // 粉丝数
  linkers_count: number; // 连接数
}

export enum EPrivilegeType {
  None = 0, // 没有认证
  Official = 1, // 官方认证
  Individual = 2, // 个人认证
  Business = 3, // 企业认证
}

export interface IHyperlink {
  name: string;
  href: string;
}

export interface IPrivilegeInfo {
  privilege_type: EPrivilegeType;
  privilege_name: string;
  description?: string;
  hyper_links?: IHyperlink[];
}

export interface IPostBatchGetNpcByLanguageReq {
  language: ILanguage;
  page: number;
  size: number;
}

export interface IPostBatchGetNpcByLanguageRes {
  language_list: ILanguage[];
  item_list: IFeedItem[];
  has_more: boolean;
}

export interface IPostBatchGetNpcForOutsiderReq {
  page: number;
  size: number;
}

export interface IPostBatchGetNpcForOutsiderRes {
  item_list: IFeedItem[]; // npc列表
  has_more: boolean;
}

export interface IWebPushKey {
  Auth: string;
  P256dh: string;
}

export interface ICreateWebPushReq {
  user_id: number;
  web_hook_url: string;
  web_push_key: IWebPushKey[];
  time_zone_offset: number; // 用户时区相对于UTC的偏移量(eg: 中国 +8  美东 -5)
}

export interface ICreateWebPushRes {
  web_push_id: number;
}
